module.exports = __webpack_public_path__ + "static/the-stringless-0e2f02aacf996268dc3380a2cb5de55c.png";